var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showMe)?_c('div',{staticClass:"policy-overlay",attrs:{"id":"overlay"},on:{"click":function($event){return _vm.closeOverlay()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }